import { useTranslation } from 'react-i18next'
import type { QuickSuggestionProps } from '@brochure/shared'

export function QuickSuggestions({
  suggestions,
  onSelect,
  disabled,
}: QuickSuggestionProps) {
  const { t } = useTranslation('common')

  return (
    <div className="flex flex-wrap gap-1.5 sm:gap-2 justify-center">
      {suggestions.map((suggestion) => (
        <button
          key={suggestion.id}
          onClick={() => onSelect(suggestion.messageKey)}
          disabled={disabled}
          className="px-3 py-1.5 sm:px-4 sm:py-2 text-xs sm:text-sm font-body text-primary border border-primary bg-transparent hover:bg-primary hover:text-white transition-colors duration-200 disabled:opacity-50"
        >
          {t(suggestion.labelKey)}
        </button>
      ))}
    </div>
  )
}
